import styled, { css } from 'styled-components';

interface StyledToggleProps {
  locked: boolean;
}

export default styled.div<StyledToggleProps>`
  display: flex;
  align-items: center;

  ${(props) =>
    props.locked &&
    css`
      pointer-events: none;
    `}

  .label {
    margin-right: 4px;
    font-size: 12px;
  }

  .toggle {
    width: 24px;
    background-color: #c4c4c4;
    cursor: pointer;
    user-select: none;
    border-radius: 31px;
    height: 12px;
    position: relative;
    transition: all 0.3s ease;
    border: 1px solid #000000;

    &.active {
      ${(props) =>
        props.locked
          ? css`
              background-color: ${props.theme.colors.secondary};
            `
          : css`
              background-color: ${props.theme.colors.secondary};
            `}
    }
  }

  .dialog-button {
    width: 10px;
    height: 10px;
    border: 1px solid ${(props) => props.theme.colors.grey};
    cursor: pointer;
    background-color: white;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: unset;
    border-radius: 50%;
    box-sizing: border-box;
    position: absolute;
    top: 1px;
    left: 13px;
    transition: all 0.3s ease;
  }

  .disabled {
    left: 1px;
  }
`;
